import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledLink = styled(Link)(({ theme, noStyles }) => ({
  ...(noStyles && {
    color: '#0c0a09',
  }),
}));

const combine = (from, to, searchConfig) => {
  if (typeof to === 'string') {
    return {
      pathname: to,
      state: {
        from: from,
      },
      search: searchConfig,
    };
  }

  return {
    ...to,
    state: {
      ...to.state,
      from: from,
    },
    search: searchConfig,
  };
};

const CommonLink = ({ className, noStyles, to, children, ...rest }) => {
  const location = useLocation();
  const search = location.search || (location.state && location.state.previousLocationSearch) || '';

  if (to) {
    return (
      <StyledLink
        className={className}
        noStyles={noStyles}
        to={combine(`${location.pathname}${search}`, to, search)}
        {...rest}>
        {children}
      </StyledLink>
    );
  }

  return children;
};

CommonLink.propTypes = {
  className: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  noStyles: PropTypes.bool,
};

export default CommonLink;
